import { QueryClient } from '@tanstack/react-query';
import dynamic from 'next/dynamic';

import NewAppLayout from '../../../../components/layouts/NewAppLayout';
import NoAccess from '../../../../providers/NoAccess';
import { detectAndBestEffortSetLanguage } from '../../../../utils/localisationUtils';
import { dehydrateReactQueryPrefetchedInfiniteQuery } from '../../../../utils/react-query-utils';
import { provisionFlags } from '../../../../utils/ServerSideFeatureFlagUtils';
import { withAuthenticatedServerSideProps } from '../../../../utils/withAuthenticatedServerSideProps';

const DynamicPage = dynamic(
  () => import('../../../../components/dynamicPages/WorkspacePage'),
  {
    ssr: false,
  },
);

export const getServerSideProps = withAuthenticatedServerSideProps(
  async (context, session) => {
    context.res.setHeader(
      'Cache-Control',
      'private, s-maxage=300, stale-while-revalidate=3600',
    );
    const queryClient = new QueryClient();
    return {
      props: {
        ...(await provisionFlags(context, queryClient, session)),
        dehydratedState: dehydrateReactQueryPrefetchedInfiniteQuery(queryClient),
        ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'app' })),
        session,
      },
    };
  },
);
const WorkspacePage = () => {
  return (
    <NoAccess>
      <NewAppLayout>
        <DynamicPage />
      </NewAppLayout>
    </NoAccess>
  );
};

export default WorkspacePage;
